import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function LifeSupport() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Page Header */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              東京生活スタート支援
            </h1>
            <p className="text-xl text-gray-600">
              外国人の方の東京での新生活を総合的にサポート
            </p>
          </div>
        </div>
      </section>

      {/* Hero Image */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative h-96 rounded-xl overflow-hidden mb-12">
            <img
              src="https://public.readdy.ai/ai/img_res/7e663bfe85a76bf9b8366e94ad4221d3.jpg"
              alt="東京生活サポート"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
              <div className="text-center text-white">
                <h2 className="text-3xl font-bold mb-4">安心の生活サポート</h2>
                <p className="text-xl">東京での新生活を完全バックアップ</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Services */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">私たちのサポートサービス</h2>
            <p className="text-xl text-gray-600">東京生活に必要なすべてをワンストップでサポート</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
            {/* Government Procedures */}
            <div className="bg-white p-8 rounded-xl shadow-lg border">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-government-line text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-semibold mb-4">役所での手続き支援</h3>
              <p className="text-gray-700 mb-6">
                日本での生活に必要な各種手続きを、経験豊富なスタッフが同行してサポート。
                言葉の壁や複雑な手続きも安心してお任せください。
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>住民登録・転入届の手続き</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>国民健康保険の加入手続き</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>年金手続きのサポート</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>マイナンバーカード申請</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>税務署での手続き</span>
                </li>
              </ul>
            </div>

            {/* Shopping & Procurement */}
            <div className="bg-white p-8 rounded-xl shadow-lg border">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-shopping-cart-line text-green-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-semibold mb-4">生活必需品の調達サポート</h3>
              <p className="text-gray-700 mb-6">
                東京での生活に必要な家具・家電から日用品まで、お客様のニーズに合わせて
                買い物案内や代理調達・設置まで対応いたします。
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>家具・家電の選定と購入代行</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>配送・設置・設定サービス</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>日用品・食材の買い物案内</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>おすすめ店舗・ブランドのご紹介</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>オンラインショッピングサポート</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Additional Services */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white p-6 rounded-xl shadow-lg border text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-bank-line text-purple-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-3">銀行口座開設</h3>
              <p className="text-gray-600 text-sm">
                日本の銀行口座開設手続きを同行サポート。必要書類の準備から手続き完了まで。
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg border text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-orange-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-3">携帯電話契約</h3>
              <p className="text-gray-600 text-sm">
                日本の携帯電話・インターネット契約のサポート。最適なプランをご提案。
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg border text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hospital-line text-red-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-3">医療機関紹介</h3>
              <p className="text-gray-600 text-sm">
                外国人対応可能な病院・クリニックのご紹介。緊急時のサポートも。
              </p>
            </div>
          </div>

          {/* Service Process */}
          <div className="bg-gray-50 p-8 rounded-xl mb-16">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">サポートの流れ</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold mx-auto mb-4">
                  1
                </div>
                <h4 className="font-semibold mb-2">ご相談</h4>
                <p className="text-sm text-gray-600">必要なサポート内容をお聞かせください</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold mx-auto mb-4">
                  2
                </div>
                <h4 className="font-semibold mb-2">プラン作成</h4>
                <p className="text-sm text-gray-600">お客様に最適なサポートプランをご提案</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold mx-auto mb-4">
                  3
                </div>
                <h4 className="font-semibold mb-2">実行</h4>
                <p className="text-sm text-gray-600">経験豊富なスタッフが同行・代行</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold mx-auto mb-4">
                  4
                </div>
                <h4 className="font-semibold mb-2">完了</h4>
                <p className="text-sm text-gray-600">アフターフォローまで安心サポート</p>
              </div>
            </div>
          </div>

          {/* Pricing */}
          <div className="bg-white p-8 rounded-xl shadow-lg border mb-16">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">サポート料金</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center p-6 border rounded-lg">
                <h4 className="text-xl font-semibold mb-4">基本サポート</h4>
                <div className="text-3xl font-bold text-blue-600 mb-4">¥15,000</div>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>役所手続き同行（1回）</li>
                  <li>銀行口座開設サポート</li>
                  <li>基本的な生活案内</li>
                </ul>
              </div>
              
              <div className="text-center p-6 border-2 border-blue-600 rounded-lg bg-blue-50">
                <div className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm mb-4">おすすめ</div>
                <h4 className="text-xl font-semibold mb-4">総合サポート</h4>
                <div className="text-3xl font-bold text-blue-600 mb-4">¥35,000</div>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>全ての役所手続きサポート</li>
                  <li>家具・家電調達代行</li>
                  <li>生活立ち上げ完全サポート</li>
                  <li>30日間アフターサポート</li>
                </ul>
              </div>
              
              <div className="text-center p-6 border rounded-lg">
                <h4 className="text-xl font-semibold mb-4">プレミアム</h4>
                <div className="text-3xl font-bold text-blue-600 mb-4">¥55,000</div>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>総合サポート内容すべて</li>
                  <li>24時間緊急サポート</li>
                  <li>専任コンシェルジュ</li>
                  <li>90日間継続サポート</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Testimonials */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">お客様の声</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white p-6 rounded-xl shadow-lg border">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-user-line text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold">田中様（アメリカ出身）</h4>
                    <p className="text-sm text-gray-600">IT企業勤務</p>
                  </div>
                </div>
                <p className="text-gray-700 text-sm">
                  「役所での手続きが不安でしたが、スタッフの方が同行してくださり、とてもスムーズに完了できました。
                  家具の選定から設置まで全てお任せできて、本当に助かりました。」
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-xl shadow-lg border">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-user-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold">李様（中国出身）</h4>
                    <p className="text-sm text-gray-600">研究職</p>
                  </div>
                </div>
                <p className="text-gray-700 text-sm">
                  「言葉の壁があって心配でしたが、中国語対応のスタッフがいて安心でした。
                  東京タワーが見える素敵なお部屋も見つけていただき、東京生活が楽しくなりました。」
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-blue-50 p-8 rounded-xl text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">東京での新生活をサポートします</h2>
            <p className="text-gray-600 mb-6">
              住まい探しから生活立ち上げまで、経験豊富なスタッフが丁寧にサポート。
              まずはお気軽にご相談ください。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/contact"
                className="bg-blue-600 hover:bg-blue-700 text-white py-3 px-8 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                無料相談を申し込む
              </a>
              <a
                href="/rooms"
                className="bg-white hover:bg-gray-50 text-blue-600 border-2 border-blue-600 py-3 px-8 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                東京タワービューの部屋を見る
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}